import { bookingsCantBookGroupsMessage } from '@wix/bi-logger-wixboost-ugc/v2';
import { shouldOpenPreferencesModal } from '@wix/bookings-services-preferences-modal/utils';
import { ControllerFlowAPI } from '@wix/yoshi-flow-editor';
import { BookingsAPI } from '../../api/BookingsApi';
import { ServiceListContext } from '../../context/createServiceListContext';
import { EnrichedService } from '../../types/types';
import { ReferralInfo } from '../../utils/bi/consts';
import { BlockNavigationReason } from '../../utils/services/getBlockNavigationReason/getBlockNavigationReason';
import { NavigationTarget } from '../navigateToNextPage/consts';
import { NavigateToNextPageAction } from '../navigateToNextPage/navigateToNextPage';
import { OpenPremiumDialogAction } from '../openPremiumDialog/openPremiumDialog';
import { openServicesPreferencesModalAction } from '../openServicesPreferencesModal/openServicesPreferencesModal';
import { bookingsUoUBookNowClickSrc16Evid1190 } from '@wix/bi-logger-bookings-data/v2';

export type OnBookFlowStartAttemptAction = ({
  service,
  referralInfo,
}: {
  service: EnrichedService;
  referralInfo: ReferralInfo;
}) => Promise<void>;

export const createOnBookFlowStartAttemptAction = ({
  flowAPI,
  bookingsApi,
  openServicesPreferencesModal,
  navigateToNextPage,
  openPremiumDialog,
  serviceListContext,
}: {
  flowAPI: ControllerFlowAPI;
  bookingsApi: BookingsAPI;
  openServicesPreferencesModal: openServicesPreferencesModalAction;
  openPremiumDialog: OpenPremiumDialogAction;
  navigateToNextPage: NavigateToNextPageAction;
  serviceListContext: ServiceListContext;
}): OnBookFlowStartAttemptAction => {
  const { isPricingPlanInstalled, bookingsSettings } = serviceListContext;

  return async ({ service, referralInfo }) => {
    if (service.blockNavigationReason) {
      if (service.blockNavigationReason === BlockNavigationReason.NOT_PREMIUM) {
        bookingsApi.notifyOwnerNonPremiumEnrollmentAttempt({
          service,
        });
      } else if (
        service.blockNavigationReason ===
        BlockNavigationReason.PRICING_PLAN_ERROR
      ) {
        bookingsApi.notifyOwnerNonPricingPlanEnrollmentAttempt({
          isPricingPlanInstalled,
          service,
        });
      }
      flowAPI.bi?.report(
        bookingsCantBookGroupsMessage({
          referralInfo: ReferralInfo.WIDGET,
        }),
      );

      openPremiumDialog();
    } else {
      const shouldOpenPreferencesModalResult = shouldOpenPreferencesModal({
        service,
        bookingsSettings,
        queryParams: flowAPI.controllerConfig.wixCodeApi.location.query || {},
        isDummyService: service.dummy,
      });

      flowAPI.bi?.report(
        bookingsUoUBookNowClickSrc16Evid1190({
          service_id: service.id!,
          destination: shouldOpenPreferencesModalResult
            ? 'preferences_modal'
            : 'calendar_page',
        }),
      );

      if (shouldOpenPreferencesModalResult) {
        openServicesPreferencesModal({ service });
      } else {
        return navigateToNextPage({
          service,
          referralInfo,
          target: NavigationTarget.CALENDAR_PAGE,
        });
      }
    }
  };
};
